import React from "react";

const DCListHeader = (props) => {
    return (<div className="grid p-0 m-0">
        <div className="col">
            Data collection list
        </div>
        {props.children}
    </div>)
}
export default DCListHeader;
